(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("YhUI", [], factory);
	else if(typeof exports === 'object')
		exports["YhUI"] = factory();
	else
		root["YhUI"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 